<template>
  <div class="FixedWatermark">
    <span>{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: "FixedWatermark",
  props: {
    text: String,
  },
};
</script>

<style lang="stylus" scoped>
@import "./FixedWatermark.styl"
</style>
